import React from "react";
import {
    Box, Stack, Typography, Icon
} from "@gti-controls-v2/web-core";
import homePageStyles from "../../../common/styles/HomePage";

const TitleSearch = () => {
    const styles = homePageStyles;

    return (
        <Stack direction="row" alignItems="center" justifyContent="center" sx={styles.titleSearchContainer}>
            <Box>
                <Icon
                    fontSize={"large"}
                    sx={styles.iconSearch}
                >
                    {'search_outlined'}
                </Icon>
            </Box>
            <Box>
                <Typography sx={styles.titleSearch}>BUSCAR EMPLEADO</Typography>
                <Typography sx={styles.subtitleSearch}>Ingresa la CURP o los datos personales</Typography>
            </Box>
        </Stack>
    );
};

export default TitleSearch;